/**
 * Valeurs Slider
 * Handles the image slider for valeurs page
 */

import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

export function initValeursSlider() {
    const slider = document.getElementById('valeurs-slider');
    
    if (!slider) return;

    new Swiper('#valeurs-slider', {
        modules: [Autoplay, EffectFade],
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        speed: 1200,
    });
}